<template>
  <div class="landing-invitation">
    <div class="section__info">
      <div class="section__info__title">
        <div class="logo slow" v-inview:animate="'fadeIn'">
          <img src="@/assets/images/main/SectionTitle/logo.svg" alt="로고"/>
          <p style="font-size: 10px; font-weight: 500;"> 대한민국 1등 자영업자 전문 금융 플랫폼 </p>
        </div>
        <p>
          펀다가 사장님께 응원을 보내요!💌
        </p>
      </div>
      <div class="section__info__content">
        <div class="section__info__content__back"></div>
        <div class="section__info__content__text__wrapper">
          <div class="section__info__content__text phone slow" v-inview:animate="'fadeInUp'">
            <p>
              펀다는 코로나가 본격화 된 지난 1년간
              <strong class="strong">
                <ICountUp :endVal="23857" :delay="200"/>
              </strong>명의 사장님과 함께<br />
               새로운 금융을 만들어 가고 있어요!
            </p>
            <div class="amount-block">
              <p>
                오늘 응원받은 사장님🎉
              </p>
              <p class="strong">
                <ICountUp :endVal="1683" :delay="200"/>명
              </p>
            </div>
            <div class="amount-block">
              <p>
                중금리 제공 금액💳
              </p>
              <p class="strong">
                <ICountUp :endVal="277739980000" :delay="300"/>원
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section__amount">
      <p>나의 가게 매출액으로 보는 예상 대출금은?</p>
      <div class="section__amount__wrapper">
        <div class="section__amount__bar">
          <div class="section__amount__bar-tooltip__wrapper"
            :style="`left: ${100 / slider.length * slider.value}%;`"
          >
            <div class="section__amount__bar-tooltip"
            >
              {{ slider.min + slider.value * 100  | toCurrency }}만원
            </div>
          </div>
          <input type="range"
            min="0"
            :max="slider.length - 1"
            :style="`background: linear-gradient(to right, white 0%, white ${100 / slider.length * slider.value}%, #0977ca ${100 / slider.length * slider.value}%, #0977ca 100%);`"
            v-model="slider.value"
            @change="setPosition"
          />
        </div>
      </div>
      <p class="available-loan-text">
        사장님 <span class="strong--medium">5월 11일</span>까지 신청하시면<br />
        약 <span class="strong">
          <ICountUp :endVal="loanAvailableAmount||0" :delay="200"/>만원
        </span>의 자금을<br />신청할 수 있어요!
      </p>
      <p class="period-of-grace-text">
        신청 기간 : 2021.05.04 ~ 2021.05.11 오후 6시<br />
        혜택 적용 : 2021.05.12 대출 시점부터 일괄 적용<br />
      </p>
    </div>
    <div class="section__carousel">
      <div class="section__carousel__wrapper">
        <v-carousel
          :show-arrows="false"
          height="200"
        >
          <v-carousel-item
            v-for="(borrower, i) in borrowers"
            :key="i"
          >
            <v-card
              color="white"
              height="100%"
            >
            <div class="d-flex flex-no-wrap aligns-center justify-space-between">
              <v-avatar
                class="ma-3"
                size="70"
                tile
              >
                <v-img
                  :src="
                    require('@/assets/images/landing/' + borrower.imageName)
                  "></v-img>
              </v-avatar>
              <v-card-title v-html="borrower.name"></v-card-title>
            </div>
            <div>
                <v-card-text>{{ borrower.content }}</v-card-text>
            </div>
            </v-card>
          </v-carousel-item>
        </v-carousel>
      </div>
    </div>
    <div class="section__footer">
      <div class="section__footer__wrapper">
        <button
          type="button"
          @click="signinKakao"
          v-inview:animate="'fadeInUp'"
        >
          <div>
            <img src="@/assets/images/kakao_symbol.svg" />
            카카오 계정으로 한도 확인하기
          </div>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import AuthService from '@/service/auth/AuthService'
import ChannelService from '@/service/channeltalk/ChannelService'

export default {
  data() {
    return {
      slider: {
        value: 10,
        min: 500,
        max: 3300,
      },
      borrowers: [
        {
          name: '박00사장님! 일식 21년차 경북<br>펀다나우 8회 이용',
          imageName: 'avatar1.png',
          content: '코로나19 직격탄에 맞고, 돈이 없어서 잠못 이루는 밤이 많았습니다. 거리두기 기간에 펀다나우 비상금을 통해서 어려운 위기를 계속 넘겼네요.',
        },
        {
          name: '김00사장님! 한식 3년차 용인<br>펀다나우 13회 사용',
          imageName: 'avatar2.png',
          content: '처음에는 코로나도 금방 지나가겠지 했는데, 무척이나 길어지면서 자금 사정이 말이 아니네요. 펀다처럼 소상공인을 돕는 서비스가 있어서 겨울 버텨내고 이겨냅니다.',
        },
        {
          name: '이00사장님! 중식 12년차 서울<br>펀다나우 35회 이용',
          imageName: 'avatar3.png',
          content: '매출은 작지 않은데, 늘 급할 때 사용 할 자금이 없어서 매번 펀다나우 도움을 잘 받고 있습니다. 1금융권에서도 외면하는데 펀다가 있어서 참 든든해요',
        },
      ],

    }
  },
  computed: {
    loanAvailableAmount() {
      const value = this.slider.min + this.slider.value * 100
      if (value === 3300) {
        return 1000
      }
      return value / 100 * 30
    },
  },
  async created() {
    this.slider.length = (this.slider.max - this.slider.min) / 100 + 1

    ChannelService.boot()
    this.setPosition()
    // Check Code
    try {
      // Code Signin
      let code = this.$route.query.code
      if (code) {
        if (code === localStorage.getItem('kakaocode')) {
          return
        }
      } else {
        return
      }
      let res = await AuthService.signinCode(code) // 코드 로그인
      if (!res) return
      await this.signin() // 로그인 성공
    } catch (e) {
      // Token Signin
      setTimeout(_ => {
        this.signinKakaoToken()
      }, 500) // 토큰 로그인
    }
  },
  methods: {
    setPosition() {
      this.$nextTick(() => {
        let barColor = 'white'
        let barBgColor = '#0977ca'
        // let percent = 100 / (this.slider.amounts.length - 1) * this.slider.value
        let percent = 100 / this.slider.length * this.slider.value
        this.slider.style = `background: linear-gradient(to right, ${barColor} 0%, ${barColor} ${percent}%,` +
            ` ${barBgColor} ${percent}%, ${barBgColor} 100%);`
      })
    },
    // Token
    async signinKakaoToken() {
      let res = await AuthService.getKakaoToken()
      if (!this._.get(res, 'access_token')) {
        return
      }
      await AuthService.signinKakaoToken(res.access_token)
      this.signin() // 로그인 성공
    },
    // Code
    async signinKakaoCode() {
      await AuthService.getKakaoCode()
    },
    async signinKakao() {
      try {
        this.signinKakaoCode() // 코드 로그인
      } catch (e) {
        this.signinKakaoToken() // 토큰 로그인
      } finally {
        // UTM
        await AuthService.sendUtmCookies()
      }
    },
    async signin() {
      await AuthService.syncProfile()
      ChannelService.boot()
      // Redirect Uri
      let redirectUri = this.$route.query.redirectUri
      if (redirectUri == null) {
        await this.$router.push({ name: 'dashboard' })
      } else {
        await this.$router.push({ path: redirectUri })
      }
    },
  }
}
</script>
<style lang="scss">
  .landing-invitation {
    .v-slider {
      &__thumb {
        width: 25px;
        height: 25px;
        position: relative;
        background: white !important;
        -webkit-transform: translate(-25%, -50%);
        transform: translate(-25%, -50%);
        box-shadow: 0 2px 8px 0 rgba(8, 68, 118, 0.16);

        &:before {
          display: none;
          left: -6px;
          top: -5.56px;
          user-select: none;
        }

        &-label {
          border-radius: 6px;
          transform: translate(-30%, -26px) !important;
          position: absolute;
          display: inline-block;
          font-size: 19px;
          font-weight: 900;
          letter-spacing: -0.41px;
          padding: 10px 60px;
          background-color: white;
          color: #1baaf1;
          left: -25px;
          height: initial !important;
          width: initial !important;

          & > div {
            // transform: none;
            word-break: keep-all;
            -webkit-transform: translateX(-40px);
            transform: translateX(-40px);
          }

          &:after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            margin-left: -7px;
            border-width: 7px;
            border-style: solid;
            border-color: white transparent transparent transparent;
          }
        }
      }

      &--horizontal {
        margin-left: 0px;
        margin-right: 0px;
        transform: unset;
      }

      &__track {
        &-container {
          height: 20px !important;
        }

        &-background {
          border-radius: 15px;
          background: #0977ca !important;
        }
        &-fill {
          border-radius: 15px;
          background: white !important;
        }
      }
    }
  }
</style>
<style lang="scss" scoped>
.landing-invitation {
  .strong {
    font-weight: 900;
    &--medium {
      font-size: 1.1em !important;
      font-weight: 700;
    }
  }
  .funda-blue--text {
    color: #1baaf1;
  }
  .section__info {
    min-height: 450px;

    &__title {
      background-color: #1baaf1;
      padding: 30px 20px;
      .logo {
        text-align: center;
        margin-bottom: 20px;
      }
      p {
        font-size: 18px;
        font-weight: 700;
        // color: #333333;
        color: white;
        text-align: center;
        word-break: keep-all;
        max-width: 350px;
        margin: 0 auto;
      }
    }
    &__content {
      position: relative;
      &__back {
        background-color: #1baaf1;
        height: 100px;
      }
      &__text {
        &__wrapper {
          position: absolute;
          top: 0;
          padding: 0 15px;
          max-width: 400px;
          margin-left: auto;
          margin-right: auto;
          left: 0;
          right: 0;
        }
        padding: 20px 30px;
        text-align: center;
        background-color: white;
        box-shadow: 12px 12px 20px 0 rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        .amount-block {
          margin: 20px 0;
          p:first-child {
            font-size: 14px;
            margin-bottom: 5px;
          }
          p:last-child {
            font-size: 20px;
          }
        }
        p:first-child {
          margin-top: 20px;
        }
        p {
          word-break: keep-all;
        }
      }
    }
  }
  .section__amount {
    overflow-x: hidden;
    padding: 40px 0 70px;
    background-color: #1baaf1;
    p {
      padding: 0 20px;
      max-width: 500px;
      color: white;
      word-break: keep-all;
      text-align: center;
      margin: 0 auto;
    }
    .available-loan-text {
      font-size: 18px;
      user-select: none;
      span {
        font-size: 22px;
      }
    }
    .period-of-grace-text {
      margin-top: 27px;
      line-height: 1.5;
    }
    &__wrapper {
      max-width: 500px;
      margin: 0 auto;
      padding: 0 40px 10px;
      text-align: center;
    }
    &__bar {
      margin-top: 65px;
      position: relative;

      input {
        -webkit-appearance: none;
        appearance: none;
        margin-bottom: 25px;
        outline: none;
        height: 10px;
        border-radius: 8px;
        background-color: #0977ca;
        padding: 0;
        cursor: pointer;

        @mixin jb( $barColor, $barBgColor, $percent ) {
          background: linear-gradient(to right, $barColor 0%, $barColor $percent, $barBgColor $percent, $barBgColor 100%);
        }
        &.v {
          &-0 {
            @include jb( white, #0977ca, 0% );
          }
          &-1 {
            @include jb( white, #0977ca, 20% );
          }
          &-2 {
            @include jb( white, #0977ca, 40% );
          }
          &-3 {
            @include jb( white, #0977ca, 60% );
          }
          &-4 {
            @include jb( white, #0977ca, 80% );
          }
          &-5 {
            @include jb( white, #0977ca, 100% );
          }
        }

        &::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #ffffff;
          cursor: pointer;
          border: none;
          box-shadow: 0 2px 8px 0 rgba(8, 68, 118, 0.16);
        }
      }

      &-tooltip {
        &__wrapper {
          position: absolute;
          bottom: -5px;
        }

        border-radius: 6px;
        display: inline-block;
        font-size: 14px;
        font-weight: 900;
        letter-spacing: -0.41px;
        padding: 8px 12px;
        background-color: white;
        color: #1baaf1;
        word-break: keep-all;
        user-select: none;

        &::after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -7px;
          border-width: 7px;
          border-style: solid;
          border-color: white transparent transparent transparent;
        }
      }
    }
  }
  .section__carousel {
    margin-bottom: 100px;
    padding: 15px;

    .v-carousel::v-deep {
      box-shadow: 0 12px 24px 0 rgba(51, 51, 51, 0.12);

      .v-card {
        padding-left: 20px;
        padding-right: 20px;
        background-color: #ffffff;

        >div {
          align-items: center;
        }

        .v-avatar {
          @media screen and (max-width: 680px) {
            height: 55px !important;
            min-width: 55px !important;
            width: 55px !important;
          }
        }

        &__title {
          font-size: 16px;
          line-height: 1.5;
          font-weight: 600;
        }
        &__text {
          padding-bottom: 0;
          padding-left: 0;
          padding-right: 0;
        }
        &__title, &__text {
          color: #333333 !important;
        }
        @media screen and (max-width: 680px) {
          height: 300px !important;

          &__title {
            font-size: 14px;
          }
        }
      }

      .v-carousel__controls {
        background: transparent;

        .v-btn {
          height: 6px;
          width: 6px;

          &--active {
            background-color: #727d8c;
          }
        }

        .v-icon {
          font-size: 6px !important;
          color: #e1e9f3;
        }
      }
      @media screen and (max-width: 680px) {
        height: 250px !important;

        .v-carousel__item {
          height: 250px !important;
        }
      }
    }
  }
  .section__footer {
    margin-bottom: 10px;
    position: fixed;
    bottom: 0;
    width: 100%;
    &__wrapper {
      padding: 20px;
      text-align: center;
    }
    button {
      margin: 0 auto;
      width: 100%;
      max-width: 400px;
      height: 64px;
      padding: 15px 15px;
      border-radius: 6px;
      font-size: 18px;
      font-weight: 900;
      box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.14);
      background-color: #ffe500;
      color: #252525;

      div {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 20px;
          margin-right: 5px;
        }
      }
    }
  }
}

@media screen and (min-width: 380px) {
  .section__amount__bar-tooltip {
    transform: translate(-30px, -60px);
  }
}

@media screen and (max-width: 380px) {
  .section__amount__bar-tooltip {
    transform: translate(-40%, -60px);
  }
}

</style>
